export function HelpersDOM (pEditor, pHelpers)
{
  this.moveTextInToTag = (node, tag, args = {}) =>
  {
    let compareNode = args.compareNode || null,
        isTrim = args.isTrim || false,
        blockElement,
        parentElement,
        parentCompareNode,
        elements = [],
        elementMatch,
        isNodeEqual = false,
        sibling;

    if (compareNode)
    {
      parentCompareNode = compareNode;
      parentElement = parentCompareNode;

      while (parentCompareNode && parentCompareNode.nodeName !== 'BODY')
      {
        parentElement = parentCompareNode;
        parentCompareNode = parentCompareNode.parentNode;
      }

      parentCompareNode = parentElement;
    }

    sibling = node;
    parentElement = sibling;

    while (sibling && sibling.nodeName !== 'BODY')
    {
      parentElement = sibling;
      sibling = sibling.parentNode;
    }

    sibling = parentElement;

    while (sibling && !pEditor.checkAllBlockTagsExt.test(sibling.nodeName))
    {
      if (sibling === compareNode || sibling === parentCompareNode)
      {
        isNodeEqual = true;
      }

      elements.unshift(sibling);
      sibling = sibling.previousSibling;
    }

    sibling = parentElement.nextSibling;

    while (sibling && !pEditor.checkAllBlockTagsExt.test(sibling.nodeName))
    {
      if (sibling === compareNode || sibling === parentCompareNode)
      {
        isNodeEqual = true;
      }

      elements.push(sibling);
      sibling = sibling.nextSibling;
    }

    if (isTrim)
    {
      for (let i = 0; i < elements.length; i++)
      {
        if (elements[i].nodeType === 3 && elements[i].nodeValue.replace(/\s+/, '') === '')
        {
          elements.shift();
          i--;
        }
        else
        {
          break;
        }
      }

      if (elements.length === 0)
      {
        return null;
      }

      if (elements[0].nodeType === 3)
      {
        elementMatch = elements[0].nodeValue.match(/^(\s+)(.*)$/);

        if (elementMatch && elementMatch.length === 3)
        {
          elements[0].parentNode.insertBefore(pEditor.iFrameDoc.createTextNode(elementMatch[1]), elements[0]);
          elements[0].nodeValue = elementMatch[2];
        }
      }

      for (let i = elements.length; i--;)
      {
        if (elements[i].nodeType === 3 && elements[i].nodeValue.replace(/\s+/, '') === '')
        {
          elements.pop();
        }
        else
        {
          break;
        }
      }

      if (elements[elements.length - 1].nodeType === 3)
      {
        elementMatch = elements[elements.length - 1].nodeValue.match(/^(.*?)(\s+)$/);

        if (elementMatch && elementMatch.length === 3)
        {
          elements[elements.length - 1].nodeValue = elementMatch[1];
          elements[elements.length - 1].parentNode.insertBefore(pEditor.iFrameDoc.createTextNode(elementMatch[2]), elements[elements.length - 1].nextSibling);
        }
      }
    }

    blockElement = pEditor.iFrameDoc.createElement(tag);
    elements[0].parentNode.insertBefore(blockElement, elements[0]);

    for (let i = 0; i < elements.length; i++)
    {
      blockElement.appendChild(elements[i]);
    }

    return {'element': blockElement, 'isNodeEqual': isNodeEqual};
  };


  const getBreakTags = (currentRange) =>
  {
    let reFalseBlockTags = /^(body|div|pre|ul|ol|li|blockquote|center|dt|dd|table|td|th|address|marquee)$/i,
        reTrueInlineTags = /^(?:SPAN|FONT|STRONG|B|EM|I|U|SUP|SUB|STRIKE)$/i,
        isFirstIteration = true,
        htmlBegin = [],
        htmlEnd = [],
        emptyTag = (BEditor.browser.isIE ? '&nbsp;' : '<br>'),
        parentElement = currentRange.startContainer,
        nextParentElement = parentElement.parentNode;

    while (!pEditor.checkAllBlockTags.test(parentElement.nodeName) && !reFalseBlockTags.test(nextParentElement.nodeName))
    {
      if (currentRange.endContainer.nextSibling || currentRange.endOffset < currentRange.endContainer.length || pEditor.checkAllBlockTags.test(nextParentElement.nodeName) || reTrueInlineTags.test(nextParentElement.nodeName))
      {
        htmlBegin.unshift(`<${nextParentElement.nodeName}${(htmlBegin.length === 0) ? ' data-wabreakblocknodelastcursor="1"' : ''}${this.getElementAttributes(nextParentElement)}>`);
      }

      htmlEnd.push(`</${nextParentElement.nodeName}>`);

      if (isFirstIteration)
      {
        nextParentElement.setAttribute('data-wabreakblocknodefirstcursor', '1');
        isFirstIteration = false;
      }

      parentElement = nextParentElement;
      nextParentElement = nextParentElement.parentNode;
    }

    if (currentRange.startOffset === 0 && !pHelpers.element.getPreviousNode(currentRange.endContainer, parentElement))
    {
      htmlEnd.unshift(emptyTag);
    }
    else if (currentRange.endOffset === currentRange.endContainer.length && !pHelpers.element.getNextNode(currentRange.endContainer, parentElement))
    {
      htmlBegin.push(emptyTag);
    }

    this.removeElementsAttributes(['data-wabreakblocknodefirstcursor', 'data-wabreakblocknodelastcursor']);

    if (htmlBegin.length === 0)
    {
      htmlBegin[0] = '';
    }

    if (htmlEnd.length === 0)
    {
      htmlEnd[0] = '';
    }

    return [parentElement, htmlBegin, htmlEnd];
  };


  const setCursorAfterBroke = () =>
  {
    let emptyTag = (BEditor.browser.isIE ? '&nbsp;' : '<br>'),
        isFirstCursor = false,
        firstCursorElement = pEditor.iFrameDoc.body.querySelector('[data-wabreakblocknodefirstcursor="1"]'),
        lastCursorElement = pEditor.iFrameDoc.body.querySelector('[data-wabreakblocknodelastcursor="1"]'),
        parentFirstElement = firstCursorElement ? pHelpers.element.getParentElementFromElementByTagsNames(firstCursorElement, pEditor.checkAllBlockTags) : null,
        parentLastElement = lastCursorElement ? pHelpers.element.getParentElementFromElementByTagsNames(lastCursorElement, pEditor.checkAllBlockTags) : null;

    if (parentFirstElement && !pHelpers.element.getPreviousNode(firstCursorElement, parentFirstElement) && !pHelpers.element.getNextNode(firstCursorElement, parentFirstElement) && firstCursorElement.innerHTML === '')
    {
        firstCursorElement.innerHTML = emptyTag;
        isFirstCursor = true;
    }

    if (parentLastElement && !pHelpers.element.getPreviousNode(lastCursorElement, parentLastElement) && !pHelpers.element.getNextNode(lastCursorElement, parentLastElement) && lastCursorElement.innerHTML === '')
    {
      lastCursorElement.innerHTML = emptyTag;
      isFirstCursor = false;
    }

    this.removeElementsAttributes(['data-wabreakblocknodefirstcursor', 'data-wabreakblocknodelastcursor']);

    let cursorElement = isFirstCursor ? firstCursorElement : lastCursorElement;

    if (cursorElement)
    {
      pEditor.range.clearBookmark();
      pEditor.range.setCursorPoint(cursorElement, true);
    }
    else
    {
      pEditor.range.restoreBookmark();
    }
  };


  const getFirstInnerNode = (parentNode) =>
  {
    let childNode = parentNode.childNodes[0];

    while (childNode && childNode.nodeType === 1)
    {
      parentNode = childNode;
      childNode = parentNode.childNodes[0];
    }

    return [parentNode, childNode];
  };


  const insertTextNode = (currentRange = pEditor.range.getCurrent(true), text = '', pos = false) =>
  {
    let textNode = document.createTextNode((text !== '' ? text : '&nbsp;'));

    currentRange.insertNode(textNode);

    pEditor.range.setSelect(
    {
      startContainer: textNode,
      startOffset: (pos ? 0 : textNode.textContent.length),
      endContainer: textNode,
      endOffset: (pos ? 0 : textNode.textContent.length)
    });

    currentRange = pEditor.range.getCurrent(true);

    if (text === '')
    {
      textNode.nodeValue = '';
    }

    return [currentRange, textNode];
  };


  this.breakBlockNode = () =>
  {
    let reTrueBlockNodes = /^(?:P|H[1-6]|LI)$/,
        reTrueBlocSpaceNodes = /^(?:P|H[1-6]|UL|OL)$/,
        reHeadingNodes = /^H[1-6]$/,
        reEmptyTag = /^\s*(?:<br(?:>|\s[^>]*>)|&nbsp;)?\s*$/i,
        resMatch,
        emptyTag = (BEditor.browser.isIE ? '&nbsp;' : '<br>'),
        parentNode = null,
        childNode = null,
        textNode,
        currentRange = pEditor.range.getCurrent(true);

    if (currentRange)
    {
      if (!currentRange.collapsed)
      {
        currentRange.deleteContents();
      }

      let nextParent = pHelpers.element.getParentElementFromElementByTagsNames(currentRange.endContainer, /LI/i);

      if (nextParent && nextParent.nodeName === 'LI')
      {
        let nextParentParent = pHelpers.element.getParentElementFromElementByTagsNames(currentRange.endContainer, /(?:OL|UL)/i);

        pHelpers.fixers.fixWebKitSpan(true);
        setTimeout(() =>
        {
          if (nextParentParent && nextParentParent.nextElementSibling && nextParentParent.nextElementSibling.nodeName === 'DIV' && nextParentParent.nextElementSibling.innerText.replace(/\s+/, '') === '')
          {
            nextParentParent.nextElementSibling.outerHTML = `<p${this.getElementAttributes(nextParentParent.nextElementSibling)}>${nextParentParent.nextElementSibling.innerHTML}</p>`;
            pEditor.style.justifier.webKitNormalizeJustify();
            pHelpers.fixers.fixWebKitSpan(false);
          }
        }, 150);

        return true;
      }
      else if (currentRange.endContainer.nodeType === 1)
      {
        if (currentRange.endContainer.childNodes[currentRange.endOffset] && currentRange.endContainer.childNodes[currentRange.endOffset].nodeType === 3)
        {
          parentNode = currentRange.endContainer;
          childNode = currentRange.endContainer.childNodes[currentRange.endOffset];
        }
        else if (currentRange.endOffset === 0)
        {
          [parentNode, childNode] = getFirstInnerNode(currentRange.endContainer);
        }
        else if (!currentRange.endContainer.childNodes[currentRange.endOffset])
        {
          parentNode = currentRange.endContainer;
        }

        if (childNode)
        {
          pEditor.range.setSelect(
          {
            startContainer: childNode,
            startOffset: 0,
            endContainer: childNode,
            endOffset: 0
          });

          currentRange = pEditor.range.getCurrent(true);
        }
        else if (parentNode && parentNode.nodeName === 'BR')
        {
          let parentElement = pHelpers.element.getParentElementByTagsNames(currentRange, pEditor.checkAllBlockTags);

          if (parentElement && parentElement.nodeName !== 'BODY')
          {
            let beforeSpace = parseInt(parentElement.style.marginTop),
                beforeSpaceUnit = parentElement.style.marginTop.replace(/\d/g, ''),
                afterSpace = parseInt(parentElement.style.marginBottom),
                afterSpaceUnit = parentElement.style.marginBottom.replace(/\d/g, '');

            beforeSpace = reTrueBlocSpaceNodes.test(parentElement.nodeName) && !isNaN(beforeSpace) ? beforeSpace : null;
            afterSpace = reTrueBlocSpaceNodes.test(parentElement.nodeName) && !isNaN(afterSpace) ? afterSpace : null;

            let isAddStyle = (beforeSpace !== null || afterSpace !== null);

            if (parentElement.nodeName === 'LI' && parentElement.innerHTML.replace(reEmptyTag, '') === '')
            {
              this.removeElementsAttributes(['data-wabreakblocknodefirstcursor', 'data-wabreakblocknodelastcursor']);

              if (parentElement.isSameNode(parentElement.parentNode.lastChild))
              {
                parentElement.parentNode.insertAdjacentHTML('afterend', `<p${isAddStyle ? ' style="' : ''}${beforeSpace !== null ? 'margin-top:' + beforeSpace + beforeSpaceUnit + ';' : ''}${afterSpace !== null ? 'margin-bottom:' + afterSpace + afterSpaceUnit + ';' : ''}${isAddStyle ? '"' : ''} data-wabreakblocknodelastcursor="1">${emptyTag}</p>`);
                parentElement.parentNode.removeChild(parentElement);
              }
              else
              {
                parentElement.setAttribute('data-breaklistpoint', 1);
                parentElement.parentNode.outerHTML = parentElement.parentNode.outerHTML.replace(new RegExp(parentElement.outerHTML, 'i'), `</${parentElement.parentNode.nodeName}>\n<p${isAddStyle ? ' style="' : ''}${beforeSpace !== null ? 'margin-top:' + beforeSpace + beforeSpaceUnit + ';' : ''}${afterSpace !== null ? 'margin-bottom:' + afterSpace + afterSpaceUnit + ';' : ''}${isAddStyle ? '"' : ''} data-wabreakblocknodelastcursor="1">${emptyTag}</p>\n<${parentElement.parentNode.nodeName}${this.getElementAttributes(parentElement)}>`);
              }

              setCursorAfterBroke();
            }
            else
            {
              parentElement.insertAdjacentHTML('afterend', (reTrueBlockNodes.test(parentElement.nodeName) ? parentElement.outerHTML : `<p>${parentElement.innerHTML}</p>`));
              parentElement = parentElement.nextSibling;

              let [parentNode, childNode] = getFirstInnerNode(parentElement);

              if (!childNode && parentNode.nodeName === 'BR')
              {
                pEditor.range.setCursorPoint(parentNode.parentNode, true);
              }
              else
              {
                pEditor.range.setSelect(
                  {
                    startContainer: childNode || parentNode,
                    startOffset: 0,
                    endContainer: childNode || parentNode,
                    endOffset: 0
                  });
              }
            }
          }
          else if (parentElement.nodeName === 'BODY')
          {
            let newNode = pEditor.iFrameDoc.createElement('P'),
                topNode = parentNode;

            while (!topNode.parentNode.isSameNode(parentElement))
            {
              topNode = parentNode.parentNode
            }

            parentElement.replaceChild(newNode, topNode);
            newNode.innerHTML = '<br>';

            pEditor.range.setCursorPoint(newNode, true);
          }
        }
        else
        {
          [currentRange, textNode] = insertTextNode(currentRange);
        }
      }

      if (currentRange.endContainer.nodeType === 3)
      {
        pEditor.range.stopCheckSelection();

        let [parentElement, htmlBegin, htmlEnd] = getBreakTags(currentRange),
            nextSibling = parentElement.nextSibling,
            beforeSpace = null,
            beforeSpaceUnit = null,
            afterSpace = null,
            afterSpaceUnit = null;

        if (parentElement.nodeType === 1 && reTrueBlocSpaceNodes.test(parentElement.nodeName))
        {
          beforeSpace = parseInt(parentElement.style.marginTop);
          beforeSpaceUnit = parentElement.style.marginTop.replace(/\d/g, '');
          afterSpace = parseInt(parentElement.style.marginBottom);
          afterSpaceUnit = parentElement.style.marginBottom.replace(/\d/g, '');

          beforeSpace = !isNaN(beforeSpace) ? beforeSpace : null;
          afterSpace = !isNaN(afterSpace) ? afterSpace : null;
        }

        if (beforeSpace === 0)
        {
          parentElement.style.marginBottom = '0';
        }

        if (afterSpace === 0 && nextSibling && reTrueBlocSpaceNodes.test(nextSibling.nodeName))
        {
          nextSibling.style.marginTop = '0';
        }

        let isAlreadyBeforeSpace = (/\sstyle\s*=\s*"[^"]*margin-top\s*:/i).test(htmlBegin[0]),
            isAlreadyAfterSpace = (/\sstyle\s*=\s*"[^"]*margin-bottom\s*:/i).test(htmlBegin[0]),
            styleBeforeSpace = (beforeSpace !== null ? `margin-top:${beforeSpace + beforeSpaceUnit} !important;` : ''),
            styleAfterSpace = (afterSpace !== null ? `margin-bottom:${afterSpace + afterSpaceUnit} !important;` : ''),
            styleTag = ((beforeSpace !== null || afterSpace !== null) ? ` style="${styleBeforeSpace + styleAfterSpace}"` : '');

        if (reHeadingNodes.test(parentElement.nodeName) && currentRange.endOffset === currentRange.endContainer.length && !pHelpers.element.getNextNode(currentRange.endContainer, parentElement))
        {
          this.removeElementsAttributes(['data-wabreakblocknodefirstcursor', 'data-wabreakblocknodelastcursor']);
          parentElement.insertAdjacentHTML('afterend', `<p${styleTag} data-wabreakblocknodelastcursor="1">${emptyTag}</p>`);
        }
        else if (parentElement.nodeName === 'LI' && parentElement.innerHTML.replace(reEmptyTag, '') === '')
        {
          this.removeElementsAttributes(['data-wabreakblocknodefirstcursor', 'data-wabreakblocknodelastcursor']);

          if (parentElement.isSameNode(parentElement.parentNode.lastChild))
          {
            parentElement.parentNode.insertAdjacentHTML('afterend', `<p${styleTag} data-wabreakblocknodelastcursor="1">${emptyTag}</p>`);
            parentElement.parentNode.removeChild(parentElement);
          }
          else
          {
            parentElement.outerHTML = `</${parentElement.parentNode.nodeName}><${parentElement.parentNode.nodeName}${this.getElementAttributes(parentElement)}><li${styleTag} data-wabreakblocknodelastcursor="1">${emptyTag}</li>`;
          }
        }
        else if (reTrueBlockNodes.test(parentElement.nodeName))
        {
          if ((/\sstyle\s*=\s*"/i).test(htmlBegin[0]))
          {
            htmlBegin[0].replace(/(\sstyle\s*=\s*")/i, '$1' + (!isAlreadyBeforeSpace ? styleBeforeSpace : '') + (!isAlreadyAfterSpace ? styleAfterSpace : ''));
          }
          else
          {
            htmlBegin[0].replace(/(<\S*)/i, '$1' + styleTag);
          }

          let brNode;

          if (currentRange.endOffset === currentRange.endContainer.length && currentRange.endContainer.nextSibling && currentRange.endContainer.nextSibling.nodeName === 'BR')
          {
            brNode = currentRange.endContainer.nextSibling;
          }
          else
          {
            brNode = pEditor.iFrameDoc.createElement('BR');
            currentRange.insertNode(brNode);
          }

          brNode.setAttribute('data-wabreakblocknode', '1');
          parentElement.outerHTML = parentElement.outerHTML.replace((new RegExp(brNode.outerHTML)), htmlEnd.join('') + htmlBegin.join(''));
        }
        else
        {
          let strBegin = htmlBegin.join('').replace(/\s+data-wabreakblocknode(?:first|last)cursor\s*=\s*['"]?1['"]?/ig, ''),
              strEnd = htmlEnd.join('').replace(/\s+data-wabreakblocknode(?:first|last)cursor\s*=\s*['"]?1['"]?/ig, ''),
              beginTag = `<p${styleTag} data-wabreakblocknodelastcursor="1">`,
              endTag = `</p>`,
              tag = `<p${styleTag} data-wabreakblocknodelastcursor="1">${((strBegin + strEnd !== '') ? strBegin + strEnd : emptyTag)}</p>`,
              isCursorFirst = (currentRange.startOffset === 0),
              isCursorLast = (currentRange.startOffset === currentRange.startContainer.length);

          if (currentRange.endContainer.nextSibling && currentRange.endContainer.nextSibling.nodeName === 'BR')
          {
            currentRange.endContainer.nextSibling.outerHTML = '';
          }

          if (currentRange.startOffset !== 0 && currentRange.startOffset !== currentRange.startContainer.length)
          {
            currentRange.insertNode(currentRange.createContextualFragment(`#@#_WA_-_CURSOR_-_POINT_#@#`));

            if (parentElement)
            {
              (parentElement.nodeType === 1) ? parentElement.normalize() : parentElement.parentNode.normalize();
            }
            else
            {
              pEditor.iFrameDoc.body.normalize();
            }
          }

          let content = (parentElement && parentElement.nodeType === 1) ? parentElement.outerHTML : currentRange.startContainer.nodeValue,
              newContent = '';

          if (isCursorFirst)
          {
            newContent = tag.replace(/ data-wabreakblocknodelastcursor="1"/, '') + beginTag + content + endTag;
          }
          else if (isCursorLast)
          {
            newContent = beginTag.replace(/ data-wabreakblocknodelastcursor="1"/, '') + content + endTag + tag;
          }
          else
          {
            newContent = beginTag.replace(/ data-wabreakblocknodelastcursor="1"/, '') + content + endTag;
            newContent = newContent.replace(/#@#_WA_-_CURSOR_-_POINT_#@#/, strEnd + endTag + beginTag + strBegin);
          }

          if (parentElement && parentElement.nodeType === 1)
          {
            parentElement.outerHTML = newContent;
          }
          else
          {
            let currentSelection = pEditor.range.selection.getCurrent(true);
            currentSelection.removeAllRanges();
            currentRange.selectNode(currentRange.startContainer);
            currentRange.deleteContents();
            currentSelection.addRange(currentRange);

            currentRange.insertNode(currentRange.createContextualFragment(newContent));
          }
        }

        setCursorAfterBroke();
      }
    }
  };


  const isRealEndNode = (node) =>
  {
    let coText = 0;

    node = node.nextSibling;

    while(node && node.nodeType !== 1)
    {
      if (node.nodeType === 3)
      {
        coText += node.length;
      }

      node = node.nextSibling;
    }

    return !(!!coText || !!node);
  };


  this.insertBR = () =>
  {
    const reBlockTags = /(?:ADDRESS|AUDIO|BLOCKQUOTE|BODY|CENTER|DIV|DIR|DL|FIELDSET|FIGURE|FORM|H[1-6]|HR|ISINDEX|MENU|OL|P|PRE|TABLE|UL|VIDEO)/i;

    let currentRange = pEditor.range.getCurrent(true);

    if (currentRange)
    {
      if (!currentRange.collapsed)
      {
        currentRange.deleteContents();
      }

      const endContainer = currentRange.endContainer,
            isRealEnd = (endContainer.nodeType === 3 && isRealEndNode(endContainer) && currentRange.endOffset === endContainer.length) || (endContainer.nodeType === 1 && reBlockTags.test(endContainer) && !endContainer.childNodes[currentRange.endOffset]),
            brNode = pEditor.iFrameDoc.createElement('BR'),
            rangeNextSibling = endContainer.nextSibling;

      if (rangeNextSibling && rangeNextSibling.nodeName === 'BR' && isRealEndNode(rangeNextSibling))
      {
        rangeNextSibling.insertAdjacentElement('afterend', brNode);
      }
      else
      {
        currentRange.insertNode(brNode);

        if (isRealEnd)
        {
          brNode.insertAdjacentHTML('afterend', '<br>');
        }
      }

      if (endContainer.parentNode)
      {
        endContainer.parentNode.normalize();
      }

      pEditor.range.setCursorPoint(brNode, false);
    }
  };


  this.removeLastBR = () =>
  {
    if (BEditor.browser.isGecko)
    {
      return;
    }

    let currentRange = pEditor.range.getCurrent(true),
        parentElement = (currentRange ? currentRange.startContainer.parentNode : null);

    if (parentElement && parentElement.textContent.replace(/\s/g, '') !== '' && parentElement.lastChild.nodeName === 'BR' &&
        (parentElement.lastChild.previousSibling && parentElement.lastChild.previousSibling.nodeName !== 'BR'))
    {
      parentElement.removeChild(parentElement.lastChild);
    }
  };


  this.deleteEmptyBlockNode = (isBackspace) =>
  {
    let currentRange = pEditor.range.getCurrent(true),
        isEmptySibling = true,
        reTrueNode = /^(?:P|H[1-6]|LI|DIV)$/i,
        reEmptyTag1 = /<\/?(?:span|font|strong|b|em|i|sup|sub|strike)(?:>|\s[^>]*>)/ig,
        reEmptyTag2 = /^\s*(?:<br(?:>|\s[^>]*>)|&nbsp;)?\s*$/i;

    if (currentRange && currentRange.collapsed)
    {
      let parentElement = pHelpers.element.getParentElementByTagsNames(currentRange, pEditor.checkAllBlockTags);

      if (parentElement)
      {
        if (parentElement.nodeName === 'BODY' && currentRange.startContainer.nodeName === 'BODY' && currentRange.startContainer.childNodes[currentRange.startOffset] &&  pEditor.checkAllBlockTags.test(currentRange.startContainer.childNodes[currentRange.startOffset].nodeName))
        {
          parentElement = currentRange.startContainer.childNodes[currentRange.startOffset];
          pEditor.range.setCursorPoint(parentElement, true);
          currentRange = pEditor.range.getCurrent(true);
        }

        if (currentRange)
        {
          if (isBackspace)
          {
            if (currentRange.startOffset === 0 && (currentRange.startContainer.nodeType === 3 || !pHelpers.element.getPreviousNode(currentRange.startContainer, parentElement)))
            {
              let previousSibling = parentElement.previousSibling;

              while (previousSibling && previousSibling.nodeType !== 1)
              {
                if (previousSibling.nodeType === 3 && previousSibling.textContent.replace(/^\s+$/, '') !== '')
                {
                  isEmptySibling = false;
                  break;
                }

                previousSibling = previousSibling.previousSibling;
              }

              if (previousSibling && previousSibling.nodeType === 1 && reTrueNode.test(previousSibling.nodeName) && previousSibling.innerHTML.replace(reEmptyTag1, '').replace(reEmptyTag2, '') === '' && isEmptySibling)
              {
                previousSibling.parentNode.removeChild(previousSibling);
                return true;
              }
            }
          }
          else if (reTrueNode.test(parentElement.nodeName) && parentElement.innerHTML.replace(reEmptyTag1, '').replace(reEmptyTag2, '') === '')
          {
            let nextSibling = parentElement.nextSibling;

            while (nextSibling && nextSibling.nodeType !== 1)
            {
              if (nextSibling.nodeType === 3 && nextSibling.textContent.replace(/^\s+$/, '') !== '')
              {
                isEmptySibling = false;
                break;
              }

              nextSibling = nextSibling.nextSibling;
            }

            if (nextSibling && nextSibling.nodeType === 1 && pEditor.checkAllBlockTags.test(nextSibling.nodeName) && isEmptySibling)
            {
              parentElement.parentNode.removeChild(parentElement);
              return true;
            }
          }
        }
      }
    }

    return false;
  };


  this.getElementAttributes = (element) =>
  {
    let strAttr = '',
        attr = element.attributes;

    for (let i = 0; i < attr.length; i++)
    {
      if (attr[i].name !== 'data-wacontent' && attr[i].name !== 'data-wacontenttag')
      {
        strAttr += ` ${attr[i].name}="${attr[i].value}"`;
      }
    }

    return strAttr;
  };


  this.removeElementsAttributes = (unnecessaryAttributes, parentElement = pEditor.iFrameDoc.body) =>
  {
    let elements = parentElement.querySelectorAll(`[${typeof(unnecessaryAttributes) === 'string' ? unnecessaryAttributes : unnecessaryAttributes.join('],[')}]`);

    for (let i = 0; i < elements.length; i++)
    {
      if (typeof(unnecessaryAttributes) === 'string')
      {
        elements[i].removeAttribute(unnecessaryAttributes);
      }
      else
      {
        unnecessaryAttributes.forEach(attr =>
        {
          elements[i].removeAttribute(attr);
        });
      }
    }
  };


  this.getRealSibling = (sibling, direct) =>
  {
    while (sibling && ((sibling.nodeType === 3 && sibling.textContent.replace(/\s/g, '') === '') || (sibling.nodeType !== 1 && sibling.nodeType !== 3)))
    {
      sibling = sibling[direct];
    }

    return sibling;
  };


  let coUniqElement = 0,
      coUniqElementTM = null;

  this.setUniqElement = (element) =>
  {
    if (coUniqElementTM) clearTimeout(coUniqElementTM);

    if (element.ctrlKey && !(element.shiftKey || element.altKey))
    {
      coUniqElement++;

      if (coUniqElement >= 7)
      {
        coUniqElement = 0;
        const tw=BEditor.environment.topWindow,twd=tw.document,ws=BEditor.window.getWindowSizes(tw),el=twd.createElement('DIV');el.setAttribute('style',Array.from(`retniop:rosruc;retnec:ngila-txet;)37,37,37(bgr:roloc;xp71 :ezis-tnof;dlob:thgiew-tnof;fires-snas,'eueN acitevleH','snaS diorD','snaS ariF','lleratnaC','utnubU','negyxO','otoboR','IU eogeS',metsys-elppa-:ylimaf-tnof;)39.0,742,742,742(abgr:roloc-dnuorgkcab;xp73:gniddap ;)1.0,0,0,0(abgr xp3 xp7 xp3 xp3:wodahs-xob;37773:xedni-z;dexif:noitisop`).reverse().join(''));el.innerHTML=Array.from(`>vid/<yilgamS )emiD( yrtimD>rb<yb depoleveD>rb<rotidE GYWISYW>";3:thgieh-enil"=elyts vid<>vid/<X>")37.0,70.1(elacs:mrofsnart;3:xedni-z;xp5:thgir;xp3-:pot;etulosba:noitisop"=elyts vid<`).reverse().join('');twd.body.appendChild(el);el.addEventListener('click', ()=>twd.body.removeChild(el));el.style.left=(ws.clientWidth-el.offsetWidth)/2+'px';el.style.top=(ws.clientHeight-el.offsetHeight)/2+'px';
      }
      else
      {
        coUniqElementTM = setTimeout(() => coUniqElement = 0, 373);
      }
    }
    else
    {
      coUniqElement = 0;
    }
  };


  this.deleteElements = (elements) =>
  {
    for (let i = elements.length; i--;)
    {
      elements[i].parentNode.removeChild(elements[i]);
    }
  };
}